import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectStrategicAxisRequestFailure({ uuid }) {
      const state = getState().find(
        ({ projectStrategicAxis }) => projectStrategicAxis.uuid === uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isEditProjectStrategicAxisRequestPending({ uuid }) {
      const state = getState().find(
        ({ projectStrategicAxis }) => projectStrategicAxis.uuid === uuid,
      );

      return state ? state.request.isPending : false;
    },
    isEditProjectStrategicAxisRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ projectStrategicAxis }) => projectStrategicAxis.uuid === uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
